import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/coaches/ctp/")({
  beforeLoad: () => {
    throw redirect({
      to: "/training-programs",
      statusCode: 301,
      throw: true,
    });
  },
  component: () => null,
  staticData: { title: "Coach Training Programs" },
});
